import React, { Children } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { Scissors, Sparkles, Palette, Flower2 } from 'lucide-react';
export function Services() {
  const {
    t
  } = useLanguage();
  const services = [{
    id: 'hair',
    title: t.services.hair,
    description: t.services.hairDesc,
    icon: Scissors,
    image: 'https://images.unsplash.com/photo-1562322140-8baeececf3df?q=80&w=2069&auto=format&fit=crop',
    color: 'bg-[#E8D5D5]'
  }, {
    id: 'nails',
    title: t.services.nails,
    description: t.services.nailsDesc,
    icon: Sparkles,
    image: 'https://images.unsplash.com/photo-1604654894610-df63bc536371?q=80&w=2070&auto=format&fit=crop',
    color: 'bg-[#F5F0EB]'
  }, {
    id: 'makeup',
    title: t.services.makeup,
    description: t.services.makeupDesc,
    icon: Palette,
    image: 'https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?q=80&w=2071&auto=format&fit=crop',
    color: 'bg-[#C9A96E]/20'
  }, {
    id: 'spa',
    title: t.services.spa,
    description: t.services.spaDesc,
    icon: Flower2,
    image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?q=80&w=2070&auto=format&fit=crop',
    color: 'bg-[#8B7E74]/20'
  }];
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 30
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section id="services" className="py-24 bg-[#FAF7F5]" data-id="element-173">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-174">
        <div className="text-center mb-16" data-id="element-175">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-[#3D3D3D] mb-4" data-id="element-176">
            {t.services.title}
          </h2>
          <div className="w-24 h-1 bg-[#8B7E74] mx-auto rounded-full" data-id="element-177" />
        </div>

        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-178">
          {services.map(service => <motion.div key={service.id} variants={item} whileHover={{
          y: -10
        }} className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300" data-id="element-179">
              <div className="h-48 overflow-hidden relative" data-id="element-180">
                <div className={`absolute inset-0 ${service.color} mix-blend-multiply opacity-20 z-10`} data-id="element-181" />
                <img src={service.image} alt={service.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-182" />
                <div className="absolute top-4 right-4 bg-white p-2 rounded-full shadow-md z-20" data-id="element-183">
                  <service.icon size={20} className="text-[#8B7E74]" data-id="element-184" />
                </div>
              </div>

              <div className="p-6" data-id="element-185">
                <h3 className="text-xl font-heading font-bold text-[#3D3D3D] mb-3" data-id="element-186">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-187">
                  {service.description}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}